import { render, staticRenderFns } from "./ReportBugDialog.vue?vue&type=template&id=4c04f7db&scoped=true&"
import script from "./ReportBugDialog.vue?vue&type=script&lang=ts&"
export * from "./ReportBugDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ReportBugDialog.vue?vue&type=style&index=0&id=4c04f7db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c04f7db",
  null
  
)

export default component.exports